
export const deliveryStatesMapping = [
    {
        state: "Pending",
        stateString: "Pendiente",
        buttons: [
            { icon: "check_box", title: "Contactar", action: "Contactar", verb: 'contactar', apiAction: { param: 'ReachMember' } },
            //{ icon: "not_listed_location", title: "Dirección no encontrada", action: "NoEncontrado" },
            { icon: "local_shipping", title: "Enviar", action: "Enviar", verb: 'registrar el envío', apiAction: { param: 'Send' } },
            { icon: 'visibility', title: "Ver", key: 5 }

        ],
        cssClass: "interested"
    },
    {
        state: "Reached",
        stateString: "Contactado",
        buttons: [
            //{ icon: "cancel", title: "Cancelar", action: "Cancelar" },
            //{ icon: "not_listed_location", title: "Dirección no encontrada", action: "NoEncontrado" },
            { icon: "local_shipping", title: "Enviar", action: "Enviar", verb: 'registrar el envío', apiAction: { param: 'Send' } },
            { icon: 'visibility', title: "Ver", key: 5 }
        ],
        cssClass: "pending"
    },
    {
        state: "Sent",
        stateString: "Enviado",
        buttons: [
            //{ icon: "undo", title: "Devolver", action: "Devolver" }
            { icon: 'visibility', title: "Ver", key: 5 }
        ],
        cssClass: "active"
    },
    {
        state: "AddressNotFound",
        stateString: "No Encontrado",
        buttons: [
            //{ icon: "cancel", title: "Cancelar", action: "Cancelar" },
            { icon: "local_shipping", title: "Enviar", action: "Enviar", verb: 'registrar el envío', apiAction: { param: 'Send' } },
            { icon: 'visibility', title: "Ver", key: 5 }
        ],
        cssClass: "interested"
    },
    {
        state: "Cancelled",
        stateString: "Cancelado",
        buttons: [
            { icon: "local_shipping", title: "Enviar", action: "Enviar", verb: 'registrar el envío', apiAction: { param: 'Send' } },
            { icon: 'visibility', title: "Ver", key: 5 }
        ],
        cssClass: "vencido"
    },
    {
        state: "Returned",
        stateString: "Devuelto",
        buttons: [
            //{ icon: "cancel", title: "Cancelar", action: "Cancelar" },
            { icon: "local_shipping", title: "Enviar", action: "Enviar", verb: 'registrar el envío', apiAction: { param: 'Send' } },
            { icon: 'visibility', title: "Ver", key: 5 }
        ],
        cssClass: "porVencer"
    },

    {
        state: 'Delivered',
        stateString: "Entregado",
        buttons: [
            { icon: "check_box", title: "Contactar", action: "Contactar", verb: 'contactar', apiAction: { param: 'ReachMember' } },
            //{ icon: "not_listed_location", title: "Dirección no encontrada", action: "NoEncontrado" },
            { icon: "local_shipping", title: "Enviar", action: "Enviar", verb: 'registrar el envío', apiAction: { param: 'Send' } },
            { icon: 'visibility', title: "Ver", key: 5 }

        ],
        cssClass: "delivered"
    },

    {
        state: 'Withdrawal',
        stateString: "Retiro",
        buttons: [
            { icon: "check_box", title: "Contactar", action: "Contactar", verb: 'contactar', apiAction: { param: 'ReachMember' } },
            //{ icon: "not_listed_location", title: "Dirección no encontrada", action: "NoEncontrado" },
            { icon: "local_shipping", title: "Enviar", action: "Enviar", verb: 'registrar el envío', apiAction: { param: 'Send' } },
            { icon: 'visibility', title: "Ver", key: 5 }

        ],
        cssClass: "withdrawal"
    },


]